import { render, staticRenderFns } from "./Amazon.vue?vue&type=template&id=7f193d2a&scoped=true"
import script from "./Amazon.vue?vue&type=script&lang=js"
export * from "./Amazon.vue?vue&type=script&lang=js"
import style0 from "./Amazon.vue?vue&type=style&index=0&id=7f193d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f193d2a",
  null
  
)

export default component.exports